(function ($, Drupal, drupalSettings, once) {
  Drupal.behaviors.galerieTextSwiper = {
    attach: function (context, settings) {
      once("galerieTextSwiper", ".swiper-galerie-text", context).forEach(function (element) {
        var that = $(element);

        new Swiper($(element)[0], {
          loop: true,
          slidesPerView: 2,
          spaceBetween: 20,
          pagination: {
            el: that.parent().find(".swiper-pagination")[0],
            type: "fraction",
          },
          navigation: {
            nextEl: that.parent().find(".swiper-button-next")[0],
            prevEl: that.parent().find(".swiper-button-prev")[0],
          },
          breakpoints: {
            900: {
              slidesPerView: 1,
            },
          },
        });
      });
    },
  };
})(jQuery, Drupal, drupalSettings, once);
